import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Image, Button, Drawer, Tag, Input, Space, Select } from 'antd';
import { getColumnSearchProps } from "../components/utils";
const { Search } = Input;

const InventoryComp = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    axios.get('https://appmobile.svurguns.cyou/Divaces/get_products.php')
      .then(response => {
        const data = response.data.products || [];
        setDevices(data);
        setFilteredDevices(data); // Initialize filteredDevices

        // Extract unique categories for Select filter
        const categories = Array.from(new Set(data.map(d => d.category).filter(Boolean)));
        setCategoryOptions(categories);

        setLoading(false);
      })
      .catch(error => {
        setError(error.message || 'Error fetching devices');
        setLoading(false);
      });
  }, []);

  // Search handler
  const handleSearch = (value) => {
    setSearchText(value);
    if (!value) {
      setFilteredDevices(devices);
      return;
    }
    const lowerValue = value.toLowerCase();
    setFilteredDevices(
      devices.filter(device =>
        (device.product_name && device.product_name.toLowerCase().includes(lowerValue)) ||
        (device.device_name && device.device_name.toLowerCase().includes(lowerValue)) ||
        (device.device_id && device.device_id.toString().includes(lowerValue)) ||
        (device.device_barcode && device.device_barcode.toLowerCase().includes(lowerValue)) ||
        (device.device_code_nfc && device.device_code_nfc.toLowerCase().includes(lowerValue)) ||
        (device.status && device.status.toLowerCase().includes(lowerValue)) ||
        (device.address_name && device.address_name.toLowerCase().includes(lowerValue)) ||
        (device.location_name && device.location_name.toLowerCase().includes(lowerValue))
      )
    );
  };

  // Drawer state
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [deviceHistory, setDeviceHistory] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const [allActivitiesLoading, setAllActivitiesLoading] = useState(false);

  const columns = [
    {
      title: 'Image',
      dataIndex: 'image_paths',
      key: 'image_paths',
      width: 80,
      render: (images) => {
        if (!Array.isArray(images)) images = [];
        if (images.length > 0) {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Image.PreviewGroup>
                <Image
                  src={images[0]}
                  alt="device"
                  style={{ width: 60, height: 60, objectFit: 'cover', zIndex: "30" }}
                  placeholder={
                    <div
                      style={{
                        width: 60,
                        height: 60,
                        background: "#f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <span style={{ color: "#bbb" }}>Loading...</span>
                    </div>
                  }
                />
                {/* Hidden images for preview group */}
                {images.slice(1).map((img, idx) => (
                  <Image
                    key={idx}
                    src={img}
                    alt={`device-${idx}`}
                    style={{ display: 'none' }}
                    placeholder={
                      <div
                        style={{
                          width: 60,
                          height: 60,
                          background: "#f0f0f0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <span style={{ color: "#bbb" }}>Loading...</span>
                      </div>
                    }
                  />
                ))}
              </Image.PreviewGroup>
            </div>
          );
        } else {
          return <span>No Image</span>;
        }
      }
    },
    { title: 'ID', dataIndex: 'id', width: 50, key: 'id' },
    { title: 'Product Name', dataIndex: 'product_name', width: 80, ...getColumnSearchProps("product_name"), key: 'product_name' },
    {
      title: 'Kategoria', dataIndex: 'category', width: 80, key: 'category',
      filters: categoryOptions.map(cat => ({ text: cat, value: cat })),
      onFilter: (value, record) => record.category === value,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Select
            placeholder="Select category"
            style={{ width: 120, marginBottom: 8, display: 'block' }}
            value={selectedKeys[0]}
            onChange={value => {
              setSelectedKeys(value ? [value] : []);
              confirm();
            }}
            allowClear
          >
            {categoryOptions.map(cat => (
              <Select.Option key={cat} value={cat} style={{ width: 120 }}>
                {cat}
              </Select.Option>
            ))}
          </Select>
          <Space>
            <Button
              type="primary"
              onClick={confirm}
              size="small"
              style={{ width: 90 }}
            >
              Filter
            </Button>
            <Button
              onClick={clearFilters}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      render: (text) => text,
    },
    { title: 'Device Name', dataIndex: 'device_name', width: 80, ...getColumnSearchProps("device_name"), key: 'device_name' },
    {
      title: 'NFC Code',
      dataIndex: 'device_code_nfc',
      width: 50,
      key: 'device_code_nfc',
      ...getColumnSearchProps("device_code_nfc"),
    },
    {
      title: 'Barcode',
      dataIndex: 'device_barcode',
      width: 80,
      key: 'device_barcode',
      ...getColumnSearchProps("device_barcode"),
      render: (barcode) => (
        barcode ? (
          <Image
            src={`https://www.barcodesinc.com/generator/image.php?code=${barcode}&style=197&type=C128B&width=250&height=100&xres=1&font=1`}
            alt="barcode"
            style={{ width: '100%', maxWidth: 120, height: 40, objectFit: 'contain' }}
          />
        ) : (
          <span>No Barcode</span>
        )
      )
    },
    {
      title: 'Location', dataIndex: 'location_name', width: 80, ...getColumnSearchProps("location_name"), key: 'location_name',
      filters: Array.from(new Set(devices.map(d => d.location_name).filter(Boolean))).map(loc => ({ text: loc, value: loc })),
      onFilter: (value, record) => record.location_name === value,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Select
            placeholder="Select location"
            style={{ width: '100%', marginBottom: 8, display: 'block' }}
            value={selectedKeys[0]}
            onChange={value => {
              setSelectedKeys(value ? [value] : []);
              confirm();
            }}
            allowClear
          >
            {Array.from(new Set(devices.map(d => d.location_name).filter(Boolean))).map(loc => (
              <Select.Option key={loc} value={loc} style={{ width: 120 }}>
                {loc}
              </Select.Option>
            ))}
          </Select>
          <Space>
            <Button
              type="primary"
              onClick={confirm}
              size="small"
              style={{ width: 90 }}
            >
              Filter
            </Button>
            <Button
              onClick={clearFilters}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      render: (text) => text,
    },
    {
      title: 'Address', dataIndex: 'address_name', width: 80, ...getColumnSearchProps("address_name"), key: 'address_name',
      filters: Array.from(new Set(devices.map(d => d.address_name).filter(Boolean))).map(addr => ({ text: addr, value: addr })),
      onFilter: (value, record) => record.address_name === value,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Select
            placeholder="Select address"
            style={{ width: '100%', marginBottom: 8, display: 'block' }}
            value={selectedKeys[0]}
            onChange={value => {
              setSelectedKeys(value ? [value] : []);
              confirm();
            }}
            allowClear
          >
            {Array.from(new Set(devices.map(d => d.address_name).filter(Boolean))).map(addr => (
              <Select.Option key={addr} value={addr} style={{ width: '100%' }}>
                {addr}
              </Select.Option>
            ))}
          </Select>
          <Space>
            <Button
              type="primary"
              onClick={confirm}
              size="small"
              style={{ width: 90 }}
            >
              Filter
            </Button>
            <Button
              onClick={clearFilters}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      render: (text) => text,
    },
    {
      title: 'Status', dataIndex: 'product_status', width: 80, ...getColumnSearchProps("product_status"), key: 'product_status',
      filters: Array.from(new Set(devices.map(d => d.product_status).filter(Boolean))).map(addr => ({ text: addr, value: addr })),
      onFilter: (value, record) => record.product_status === value,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Select
            placeholder="Select address"
            style={{ width: '100%', marginBottom: 8, display: 'block' }}
            value={selectedKeys[0]}
            onChange={value => {
              setSelectedKeys(value ? [value] : []);
              confirm();
            }}
            allowClear
          >
            {Array.from(new Set(devices.map(d => d.product_status).filter(Boolean))).map(addr => (
              <Select.Option key={addr} value={addr} style={{ width: '100%' }}>
                {addr}
              </Select.Option>
            ))}
          </Select>
          <Space>
            <Button
              type="primary"
              onClick={confirm}
              size="small"
              style={{ width: 90 }}
            >
              Filter
            </Button>
            <Button
              onClick={clearFilters}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      render: (product_status) => {
        let color = 'default';
        switch ((product_status || '').toLowerCase()) {
          case 'working':
            color = 'green';
            break;
          case 'broken':
            color = 'red';
            break;
          case 'repair':
            color = 'orange';
            break;
          case 'new':
            color = 'blue';
            break;
          case 'maintenance':
            color = 'gold';
            break;
          default:
            color = 'default';
        }
        return <Tag color={color}>{product_status ? product_status.toUpperCase() : 'UNKNOWN'}</Tag>;
      }
    },
    { title: 'Moved At', dataIndex: 'moved_at', width: 80, key: 'moved_at' },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => handleShowHistory(record.id)}
        >
          Get History
        </Button>
      ),
    },
  ];

  const handleShowHistory = (Id) => {
    setDrawerVisible(true);
    setHistoryLoading(true);
    setSelectedDeviceId(Id);
    axios.get(`https://appmobile.svurguns.cyou/Divaces/get_device_history.php?device_id=${Id}`)
      .then(response => {
        setDeviceHistory(response.data.history || response.data || []);
        setHistoryLoading(false);
      })
      .catch(error => {
        setDeviceHistory([]);
        setHistoryLoading(false);
      });
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
    setDeviceHistory([]);
    setSelectedDeviceId(null);
  };

  const historyColumns = [
    { title: 'Device ID', dataIndex: 'device_id', key: 'device_id' },
    { title: 'Product Name', dataIndex: 'product_name', key: 'product_name' },
    { title: 'User', dataIndex: 'username', key: 'username' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    { title: 'Old Location', dataIndex: 'old_location_name', key: 'old_location_name' },
    { title: 'New Location', dataIndex: 'new_location_name', key: 'new_location_name' },
    { title: 'Moved At', dataIndex: 'moved_at', key: 'moved_at' },
  ];

  const handleShowAllActivities = () => {
    setDrawerVisible(true);
    setAllActivitiesLoading(true);
    setSelectedDeviceId("All Activities");
    axios.get("https://appmobile.svurguns.cyou/Divaces/get_all_activities.php")
      .then(response => {
        setDeviceHistory(response.data.history || []);
        setAllActivitiesLoading(false);
      })
      .catch(error => {
        setDeviceHistory([]);
        setAllActivitiesLoading(false);
      });
  };

  return (
    <div>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Search
          placeholder="Search by Product Name, Device Name, ID, Barcode, NFC..."
          allowClear
          enterButton="Search"
          onSearch={handleSearch}
          onChange={e => handleSearch(e.target.value)}
          value={searchText}
          style={{ marginBottom: 16, maxWidth: 400 }}
        />
        <Button onClick={handleShowAllActivities}>Bütün hərəkətlər</Button>
      </Space>
      {loading && <div>Loading...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {!loading && !error && (
        <>
          <Table
            dataSource={filteredDevices}
            columns={columns}
            rowKey="movement_id"
            pagination={{ pageSize: 8, showTotal: (total) => `Total ${total} items`, }}
          />
          <Drawer
            title={`Device History (ID: ${selectedDeviceId})`}
            placement="right"
            width={700}
            onClose={handleDrawerClose}
            open={drawerVisible}
          >
            {historyLoading ? (
              <div>Loading history...</div>
            ) : (
              <div>
                {Array.isArray(deviceHistory) && deviceHistory.length > 0 ? (
                  <Table
                    dataSource={deviceHistory}
                    columns={historyColumns}
                    rowKey="movement_id"
                    pagination={false}
                    size="small"
                    bordered
                  />
                ) : (
                  <div>No history found.</div>
                )}
              </div>
            )}
          </Drawer>
        </>
      )}
    </div>
  );
};

export default InventoryComp;
